import { Info } from "lucide-react";
import { Input } from "./ui/input";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip"
import { Button } from "./ui/button";
import TooltipInfo from "./tooltipInfo";

export function InputText({ formik, id, label, type = "text", helpText, disabled }) {
  return (
    <div className="flex flex-col gap-2 bg-white border border-border rounded-sm p-4">
      <div className="flex flex-row items-center">
        <p className="text-md font-semibold">{label}</p>
        {helpText && <TooltipInfo helpText={helpText} />}
      </div>
      <Input
        disabled={disabled}
        required
        id={id}
        name={id}
        type={type}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values[id]}
      />
      {formik.touched[id] && formik.errors[id] && <span className="text-sm text-customDanger">{formik.errors[id]}</span>}
    </div>
  )
}